import ShoppingCartGridItemsTableComponent from "../../../components/shoppingCart/ShoppingCartGridItemsTableComponent";
import ShoppingCartSummaryComponent from "../../../components/shoppingCart/ShoppingCartSummaryComponent";
import useShoppingCart from "../../../hooks/useShoppingCart.hook";
import { useNavigate } from "react-router-dom";
import "./shoppingCartPageComponent.scss";

export const ShoppingCartPageComponent = () => {
  const { cartItems } = useShoppingCart();
  const navigate = useNavigate();

  if (!cartItems.length) {
    return (
      <div className="emptyCartContainer">
        <div className="emptyCartContent">
          {/* <img src="/assets/images/empty-cart.svg" alt="Empty Cart" className="emptyCartImage" /> */}
          <h1>העגלה שלך ריקה</h1>
          <p>לא הוספת עדיין מוצרים לעגלה. חזור לחנות כדי להתחיל לקנות!</p>
          <button className="primaryButton" onClick={() => navigate("/")}>
            חזרה לחנות
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="container shoppingCartPageContainer">
      <h1>עגלת הקניות</h1>
      <ShoppingCartGridItemsTableComponent />
      <ShoppingCartSummaryComponent />
    </div>
  );
};

export default ShoppingCartPageComponent;
